import { useMemo } from 'react';
import {
  hasPermission,
  hasAnyPermission,
  normalizePermissions,
  PermissionUser,
  Permission,
} from '../lib/permissions';

export function usePermissions() {
  const user = useMemo<PermissionUser | null>(() => {
    const stored = localStorage.getItem('admin_user');
    if (stored) {
      try {
        return JSON.parse(stored) as PermissionUser;
      } catch {
        return null;
      }
    }
    return null;
  }, []);

  const permissions = useMemo(() => normalizePermissions(user), [user]);

  return {
    user,
    permissions,
    can: (permission: Permission | string) => hasPermission(user, permission),
    canAny: (perms: (Permission | string)[]) => hasAnyPermission(user, perms),
  };
}
